import { jsx, jsxs } from "react/jsx-runtime";
import { Box } from "../Box/Box.mjs";
import "../Text/TextContext.mjs";
import "../Heading/HeadingContext.mjs";
import "../../css/lineHeightContainer.css.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
import "../../css/reset/reset.css.mjs";
import "../../css/atoms/sprinkles.css.mjs";
import "../../hooks/useIcon/icon.css.mjs";
import "../../css/typography.css.mjs";
import { IconAutoAwesome } from "../icons/IconAutoAwesome/IconAutoAwesome.mjs";
import { IconCheckCircle } from "../icons/IconCheckCircle/IconCheckCircle.mjs";
import { IconErrorOutline } from "../icons/IconErrorOutline/IconErrorOutline.mjs";
import { IconInfoOff } from "../icons/IconInfoOff/IconInfoOff.mjs";
import { Columns } from "../Columns/Columns.mjs";
import { Column } from "../Column/Column.mjs";
import { textAlignedToIcon } from "../../css/textAlignedToIcon.css.mjs";
import { DefaultTextPropsProvider } from "../private/defaultTextProps.mjs";
const icons = {
  positive: IconCheckCircle,
  info: IconInfoOff,
  promote: IconAutoAwesome,
  critical: IconErrorOutline
};
const Notice = ({ tone = "info", data, children, ...restProps }) => {
  const Icon = icons[tone];
  return /* @__PURE__ */ jsx(
    Box,
    {
      role: "alert",
      "aria-live": "polite",
      ...buildDataAttributes({ data, validateRestProps: restProps }),
      children: /* @__PURE__ */ jsxs(Columns, { space: "xsmall", children: [
        /* @__PURE__ */ jsx(Column, { width: "content", children: /* @__PURE__ */ jsx(Icon, { tone }) }),
        /* @__PURE__ */ jsx(Column, { children: /* @__PURE__ */ jsx(Box, { className: textAlignedToIcon.standard, children: /* @__PURE__ */ jsx(DefaultTextPropsProvider, { tone, children }) }) })
      ] })
    }
  );
};
export {
  Notice
};
